/**
 * PressureRole - Role para conversão de unidades de pressão
 *
 * Implementa os 4 pilares: Convert, Cast, Validate, Format
 *
 * @example
 * const pressure = new PressureRole();
 * pressure.convert('bar', 'pascal', 1)        // 100000
 * pressure.convert('atmosphere', 'psi', 1)    // 14.696
 * pressure.cast('pascal', '100 Pa')           // 100
 * pressure.validate('pascal', 100)            // { valid: true, errors: [] }
 * pressure.format('bar', 1.5)                 // "1.5 bar"
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { PRESSURE_UNITS, PRESSURE_ALIASES } from "./constants";

// =============================================================================
// PRESSURE ROLE CLASS
// =============================================================================

export class PressureRole extends SimpleRole {
  readonly name = "pressure";
  readonly base = "pascal";
  readonly units = PRESSURE_UNITS;
  readonly aliases = PRESSURE_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Pressure cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da PressureRole */
export const pressureRole = new PressureRole();
